// assets/disable-loader.js
(function () {
  function disable() {
    // 1) Stop any "turn-on / turn-off" effects by force-resetting hero-sec
    document.querySelectorAll('#hero-sec').forEach((el) => {
      el.style.animation = 'none';
      el.style.opacity = '1';
      el.style.backgroundColor = 'transparent';
    });

    // 2) Remove the navigation interception (the script that e.preventDefault + delays)
    // Cloning removes all previously attached event listeners.
    document.querySelectorAll('a.nav-linkd').forEach((a) => {
      const clone = a.cloneNode(true);
      a.parentNode.replaceChild(clone, a);
    });
  }

  // Run after everything (including inline section scripts) has had a chance to attach listeners
  window.addEventListener('load', disable);
})();
